<!-- Segunda fila -->
<div class="row">

    <div class="col-6">
        <label for="iccid">Iccid<span class="required">*</span></label>
        <input type="text" class="form-control input-label" [disabled]="true" [value]="iccid" />
    </div>
</div>
<div class="row">
    <div class="col">
        <label for="iccid">Error<span class="required">*</span></label>
        <input type="text" class="form-control input-label" [disabled]="true" [value]="errorMessage" />
    </div>
</div>
<div class="row">
    <div class="col-12">
        <label for="iccid">Description<span class="required">*</span></label>
        <textarea class="form-control input-label" type="text" class="form-control input-label"
            [(ngModel)]="description"></textarea>
    </div>
</div>

<!-- Cuarta fila -->
<div class="row mt-2">
    <div class="col text-end">
        <button *ngIf="isEditing" class="btn btn-primary w-100 w-md-auto" (click)="createTicket()">
            Update Ticket
        </button>
        <button *ngIf="!isEditing" class="btn btn-primary w-100 w-md-auto" (click)="createTicket()">
            Create Ticket
        </button>
    </div>
</div>